import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {ContractPriceType} from "../../types/contract-price.type";
import {ContractPriceMethodType} from "../../types/contract-price-method.type";


export class CreateProgramForContractDialogCtrl implements IController {
  form: any;
  contract: any;
  createdProgramType: any;
  onSetProgramType: Function;
  onChanges: Function;


  public contractPriceTypes: ContractPriceType[];
  public contractPriceMethodTypes: ContractPriceMethodType[];
  public usedProgramTypesMap: any;
  public availableProgramTypes: any;
  public availablePriceTypesByMethod: any;

  constructor(private contractsConstants) {
    this.contractPriceTypes = Object.values(ContractPriceType);
    this.contractPriceMethodTypes = Object.values(ContractPriceMethodType);
    this.usedProgramTypesMap = {}
    this.availablePriceTypesByMethod = contractsConstants.availableContractPriceTypesByMethod
  }

  $onInit() {
    this.availableProgramTypes = _.filter(this.contract.entryList, (programType) => {
      return !programType.enabled;
    })
  }

  onPriceRangeChanged(programSetting) {
    _.unset(programSetting, 'priceType');
    this.onChanges({programType: this.createdProgramType});
  }
}

angular
  .module('bringoz.admin.contracts')
  .component('createProgramForContractDialog', {
    require: {
      form: '^form'
    },
    bindings: {
      contract: '<',
      createdProgramType: '<',
      onSetProgramType: '&',
      onChanges: '&'
    },
    template: require('./create-program-for-contract-dialog.html').default,
    controller: CreateProgramForContractDialogCtrl
  });
